import { InjectionToken, Provider } from '@angular/core';

export type SystemApiMeteringConfig = {
	refreshInterval: number;
};

export const SYSTEM_API_METERING_CONFIG_DEFAULTS: SystemApiMeteringConfig = {
	refreshInterval: 200
};

/**
 * Defined separately of the standard configuration to prove that the faster rate
 * runs well. Intended for use only in WWB 8 as a test application.
 * We can attempt to use this in other apps if proven stable
 */
export const SYSTEM_API_METERING_FAST_CONFIG_DEFAULTS: SystemApiMeteringConfig = {
	refreshInterval: 100
};

export const SYSTEM_API_METERING_CONFIG = new InjectionToken<SystemApiMeteringConfig>('SYSTEM_API_METERING_CONFIG', {
	providedIn: 'root',
	factory: (): SystemApiMeteringConfig => SYSTEM_API_METERING_CONFIG_DEFAULTS
});

export function provideSystemApiMeteringConfig(config: Partial<SystemApiMeteringConfig>): Provider {
	return {
		provide: SYSTEM_API_METERING_CONFIG,
		useValue: { ...SYSTEM_API_METERING_CONFIG_DEFAULTS, ...config }
	};
}
